import React from 'react';
import { resolveStyle } from './base_components';

type Props = {
  style?: any;
  value: string;
  options: string[];
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  children?: any;
};

export default class Select extends React.PureComponent<Props> {
  _onChange = (e) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  };
  render() {
    const {
      style,
      value,
      options,
      placeholder,
      className: extraClass,
      onChange: _,
      children,
      ...other_props
    } = this.props;

    const opts = options.map(_mapOpt);
    if (placeholder && !value) {
      const def = (
        <option key='default' disabled selected hidden value=''>
          {placeholder}
        </option>
      );
      opts.unshift(def);
    }

    const { className, inlineStyle } = resolveStyle(style, extraClass);

    return (
      <select
        className={'base-component-text-input ' + className}
        style={inlineStyle}
        {...other_props}
        value={value}
        onChange={this._onChange}
      >
        {opts}
        {children}
      </select>
    );
  }
}
function _mapOpt(opt, i) {
  let ret;
  if (typeof opt === 'string') {
    ret = (
      <option key={i} value={opt}>
        {opt}
      </option>
    );
  } else if (opt.value !== undefined && opt.text !== undefined) {
    ret = (
      <option key={i} value={opt.value}>
        {opt.text}
      </option>
    );
  }
  return ret;
}
